// extracted by mini-css-extract-plugin
var _1 = "ra-filter-footer";
export { _1 as "filterFooterCls" }
